import 'babel-polyfill';
import * as angular from 'angular';
import AppModule from './app.module';

angular.element(document).ready(() => {
  angular.bootstrap(document, [AppModule], {strictDi: true});
});



// WEBPACK FOOTER //
// ./src/app/app.bootstrap.js